import React, { FC, useEffect, useState, useCallback, useRef } from "react";

import { AxiosError } from "axios";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faSearch } from "@fortawesome/free-solid-svg-icons";
import useSpinnerLoader from "../../../../shared/components/spinner-loader";
import TableHeaderOrdering, {
  Header,
  OrderData,
} from "../../../../shared/components/table-header-ordering";
import { notificationService } from "../../../../shared/services/notification-service";
import TableRowNoData from "../../../../shared/components/molecules/commons/table-row-no-data";
import { HrOnlineService } from "../../../../shared/services/Report/HrOnline/hr-online";
import {
  Document,
  Page,
  View,
  Text,
  PDFDownloadLink,
  Font,
} from "@react-pdf/renderer";

import moment from "moment";
import PaginationForm from "../../../../shared/components/molecules/commons/pagination-form";

Font.register({
  family: "kanit-regular",
  src: "https://fonts.gstatic.com/s/kanit/v1/L6VKvM17ZmevDynOiw7H9w.ttf",
});
Font.register({
  family: "kanit-200",
  src: "https://fonts.gstatic.com/s/kanit/v1/wfLWkj1C4tYl7MoiFWS3bA.ttf",
});
// Type definition for PDFDownloadLink render function
interface PDFDownloadLinkRenderProps {
  blob: Blob | null;
  url: string | null;
  loading: boolean;
  error: Error | null;
}

const thaiMonths = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

const ReportEmployeeLevelTrainingKeyCoursesListPage: FC = () => {
  const [queryParams, setQueryParams] = useState<any>({
    ordering_field: "",
    ordering: "",
    page: 1,
    page_size: 10,
    level: "",
  });
  const [data, setData] = useState<any>([]);
  const [dataExport, setDataExport] = useState<any>([]);
  const { loaderComponent, startLoading, stopLoading } = useSpinnerLoader();
  const loadingRef = useRef({ startLoading, stopLoading });
  loadingRef.current = { startLoading, stopLoading };
  const [displayLevel, setDisplayLevel] = useState("");

  const headers: Header[] = [
    {
      label: "ลำดับ",
      field: "index",
      order: null,
      isOrder: true,
    },
    {
      label: "ชื่อ-นามสกุล",
      field: "name",
      order: null,
      isOrder: true,
    },
    {
      label: "ตำแหน่ง",
      field: "position_name",
      order: null,
      isOrder: true,
    },
    {
      label: "กอง/สำนักงาน",
      field: "department_offices_name",
      order: null,
      isOrder: true,
    },
    {
      label: "ระดับการศึกษา",
      field: "graduation_level",
      order: null,
      isOrder: true,
    },
    {
      label: "สาขา",
      field: "graduation_major",
      order: null,
      isOrder: true,
    },
    {
      label: "ปีเกษียณ",
      field: "retirement_year",
      order: null,
      isOrder: true,
    },
    {
      label: "เงินเดือน",
      field: "salary",
      order: null,
      isOrder: true,
    },
  ];

  const fetchData = useCallback(
    async (params: any) => {
      loadingRef.current.startLoading();
      try {
        const result =
          await HrOnlineService.getReportEmployeeLevelTrainingKeyCoursesList(
            params
          );
        const resultAll =
          await HrOnlineService.getReportEmployeeLevelTrainingKeyCoursesList({
            ...params,
            page_size: 10000,
            page: 1,
          });
        setData(result);
        setDataExport(resultAll);
        setDisplayLevel(params.level);
      } catch (error) {
        const err = error as AxiosError;
        notificationService.dangerNotification(
          "โหลดข้อมูลไม่สำเร็จ",
          err.message
        );
      } finally {
        loadingRef.current.stopLoading();
      }
    },
    [
      queryParams.ordering,
      queryParams.page_size,
      queryParams.page,
      queryParams.level,
    ]
  );

  const tableRowNoData = () => {
    if (data.rows?.length === 0) {
      return <TableRowNoData colspan={7} />;
    }
    return null;
  };

  const zw = "\u200B";  

  const PDF: React.FC<{ data: any }> = ({ data }) => (
    <Document>
      <Page size="A4" orientation="landscape" style={{ padding: 20, fontFamily: "kanit-regular" }}>
        <View style={{ marginBottom: 20 }}>
          <Text
            style={{
              fontSize: 16,
              textAlign: "center",
              marginBottom: 1,
              fontFamily: "kanit-regular",
            }}
          >
            {"องค์การตลาดเพื่อเกษตรกร" + zw}
          </Text>
          <Text
            style={{
              fontSize: 16,
              textAlign: "center",
              marginBottom: 1,
              fontFamily: "kanit-regular",
            }}
          >
            {"รายงานแบ่งประเภท :  ประวัติการศึกษา พนักงาน/ลูกจ้าง" + zw}
          </Text>
          <Text
            style={{
              fontSize: 16,
              textAlign: "center",
              marginBottom: 1,
              fontFamily: "kanit-regular",
            }}
          >
            {"ประจำวันที่" + zw}{" "}
            {moment().format("D") +
              " " +
              thaiMonths[moment().month()] +
              " " +
              (moment().year() + 543) +
              zw}
          </Text>
        </View>

        {/* ตาราง - ครอบทั้งตารางด้วย View เดียว */}
        <View
          style={{
            border: "1px solid black",
          }}
        >
          {/* หัวตาราง - ใช้ View ห่อแต่ละเซลล์เพื่อให้เส้นขอบลากเต็มความสูง */}
          <View
            style={{
              flexDirection: "row",
              borderBottom: "1px solid black",
              alignItems: "stretch",
            }}
            fixed
          >
            <View style={{ width: "7%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"ลำดับที่" + zw}</Text>
            </View>
            <View style={{ width: "12%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"ชื่อ-นามสกุล" + zw}</Text>
            </View>
            <View style={{ width: "28%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"ตำแหน่ง" + zw}</Text>
            </View>
            <View style={{ width: "10%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"กอง/สำนักงาน" + zw}</Text>
            </View>
            <View style={{ width: "9%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"ระดับการศึกษา" + zw}</Text>
            </View>
            <View style={{ width: "24%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"สาขา" + zw}</Text>
            </View>
            <View style={{ width: "7%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"ปีเกษียณ" + zw}</Text>
            </View>
            <View style={{ width: "7%", padding: 2, justifyContent: "center" }}>
              <Text style={{ fontSize: 7, textAlign: "center", fontFamily: "kanit-regular" }}>{"เงินเดือน" + zw}</Text>
            </View>
          </View>

          {/* ข้อมูลพนักงาน - ใช้ View ห่อแต่ละเซลล์ เพื่อให้เส้นแนวตั้งลากเต็มความสูงแถว */}
          {data.rows?.map((item: any, index: any) => (
            <View
              key={index}
              wrap={false}
              style={{
                flexDirection: "row",
                borderBottom:
                  index < data.rows.length - 1 ? "1px solid black" : "none",
                alignItems: "stretch",
              }}
            >
              <View style={{ width: "7%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
                <Text style={{ fontSize: 8, textAlign: "center", fontFamily: "kanit-200" }}>{index + 1}</Text>
              </View>
              <View style={{ width: "12%", padding: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, textAlign: "left", fontFamily: "kanit-200" }}>{(item.name || "") + zw}</Text>
              </View>
              <View style={{ width: "28%", padding: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, textAlign: "left", fontFamily: "kanit-200" }}>{(item.position_name || "") + zw}</Text>
              </View>
              <View style={{ width: "10%", padding: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, textAlign: "left", fontFamily: "kanit-200" }}>
                  {(item.department_offices_name || item.division_group_office_name || item.structure_departments_name || "-") + zw}
                </Text>
              </View>
              <View style={{ width: "9%", padding: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, textAlign: "left", fontFamily: "kanit-200" }}>{(item.graduation_level ?? "") + zw}</Text>
              </View>
              <View style={{ width: "24%", padding: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, textAlign: "left", fontFamily: "kanit-200" }}>{(item.graduation_major || "") + zw}</Text>
              </View>
              <View style={{ width: "7%", padding: 2, borderRight: "1px solid black", justifyContent: "center" }}>
                <Text style={{ fontSize: 8, textAlign: "center", fontFamily: "kanit-200" }}>{(item.retirement_year ?? "") + zw}</Text>
              </View>
              <View style={{ width: "7%", padding: 2, justifyContent: "center" }}>
                <Text style={{ fontSize: 8, textAlign: "right", fontFamily: "kanit-200" }}>
                  {item.salary ? item.salary.toLocaleString() : "-" + zw}
                </Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

  const onChangePageSize = (page_size: number) => {
    setQueryParams({
      ...queryParams,
      page_size: page_size,
    });
  };

  const onChangePage = (page: number) => {
    setQueryParams({
      ...queryParams,
      page: page,
    });
  };
  useEffect(() => {
    fetchData(queryParams);
  }, [fetchData]);

  return (
    <>
      <div className="d-flex justify-content-between py-4">
        <h2 className="text-mof-primary m-0">
          {/* รายงานรายชื่อพนักงานระดับ {displayLevel} ที่อบรมหลักสูตรสำคัญตามระดับ */}
          รายงานแบ่งประเภท :  ประวัติการศึกษา พนักงาน/ลูกจ้าง
        </h2>
      </div>
      {loaderComponent}
      <div className="row">
        <label className="form-label">ระดับ</label>
        <div className="col-sm-12 col-md-2">
          <select
            className="form-select"
            value={queryParams.level}
            onChange={(e) => {
              setQueryParams({
                ...queryParams,
                level: e.target.value,
              });
            }}
          >
            <option value="">ทั้งหมด</option>
            {[...Array(12)].map((_, i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </select>
        </div>
        <div className="col-sm-12 col-md-10 d-flex justify-content-end">
          <PDFDownloadLink
            document={<PDF data={dataExport} />}
            // fileName={`รายงานรายชื่อพนักงานระดับ ${
            //   queryParams.level ? queryParams.level : "ทั้งหมด"
            // } ที่อบรมหลักสูตรสำคัญตามระดับ_${
            //   queryParams.level ? queryParams.level : "ทั้งหมด"
            // }.pdf`}
            fileName={`รายงานแบ่งประเภท :  ประวัติการศึกษา พนักงาน/ลูกจ้าง.pdf`}
          >
            {
              (({ loading }: any) => (
                <Button
                  variant="primary"
                  className="btn-action btn-mof-primary me-2"
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faFileExport} className="me-2" />
                  {loading ? "Loading..." : "Export"}
                </Button>
              )) as any
            }
          </PDFDownloadLink>
        </div>
      </div>

      <div className="overflow-auto mt-3">
        <Table striped bordered hover>
          <thead>
            <TableHeaderOrdering
              headers={headers}
              onChangeOrder={(orderData: OrderData) => {
                setQueryParams({
                  ...queryParams,
                  ordering_field: orderData.field,
                  ordering: orderData.order,
                });
              }}
              isShow={true}
            />
          </thead>
          <tbody>
            {data.rows?.map((data: any, index: any) => {
              return (
                <ReportEmployeeLevelTrainingKeyCoursesRow
                  key={index}
                  {...data}
                  index={index + 1}
                />
              );
            })}
            {tableRowNoData()}
          </tbody>
        </Table>
      </div>
      <div className="">
        <PaginationForm
          current_page={queryParams.page}
          count={data.count}
          page_size={queryParams.page_size}
          onChangePageSize={onChangePageSize}
          onChangePage={onChangePage}
        />
      </div>
    </>
  );
};

const ReportEmployeeLevelTrainingKeyCoursesRow: FC<any> = ({
  index,
  name,
  position_name,
  department_offices_name,
  division_group_office_name,
  structure_departments_name,
  salary,
  graduation_level,
  graduation_major,
  retirement_year,
}) => {
  return (
    <tr>
      <td>{index}</td>
      <td>{name}</td>
      <td>{position_name}</td>
      <td>
        {department_offices_name ||
          division_group_office_name ||
          structure_departments_name ||
          "-"}
      </td>
      <td>{graduation_level}</td>
      <td>{graduation_major}</td>
      <td>{retirement_year}</td>
      <td>{salary ? salary.toLocaleString() : "-"}</td>
    </tr>
  );
};

export default ReportEmployeeLevelTrainingKeyCoursesListPage;
